import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import { instance } from "Actions/AxiosInstance";
import DynamicForm from "Component/DynamicForm";
import { textinputconverter } from "Component/DynamicForm/Fields/Text";
import { textareainputconverter } from "Component/DynamicForm/Fields/Textarea";
import { withSnackbar } from "notistack";
import React, { Component } from "react";
import { selectinputconverter } from "Component/DynamicForm/Fields/Select";

class define extends Component {
  constructor(props) {
    super(props);
    this.state = {
      postData: props.postData,
      hiringPlans: props.initData && props.initData.hirirngplan,
    };

    this.onSubmit = this.onSubmit.bind(this);
    this.handleBlur = this.handleBlur.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(key, value) {
    const { postData } = this.state;
    postData[key] = value;
    this.setState({
      postData,
    });
  }

  async componentDidMount() {
    // this.getHiringPlanList();
    this.props.onRef({
      onNext: this.onSubmit,
      onSaveDraft: this.onSaveDraft,
    });
  }

  // getHiringPlanList = () => {
  //   instance.get('recruit/initrequisition').then((result) => {
  //     this.setState({ hiringPlans: result.data.result });
  //   }).catch((error) => {
  //     this.props.enqueueSnackbar(
  //       error.response ? error.response.data.error.message : error.message,
  //       { variant: "error" },
  //     );
  //   });
  // }

  onSubmit() {
    const { postData } = this.state;

    if (!postData.name) {
      this.props.enqueueSnackbar("Please add requisition title", {
        variant: "error",
      });
    } else if (!postData.hiringplanid) {
      this.props.enqueueSnackbar("Please select hiring plan", {
        variant: "error",
      });
    } else {
      this.props.onNextClick(postData);
    }
  }

  handleBlur(value, key) {
    const { selectedReview } = this.state;
    if (value) {
      instance
        .post("recruit/checkuniquereviewsructurename", {
          structurename: value,
          reviewstructureid: selectedReview && selectedReview.reviewstructureid,
        })
        .then((result) => {
          selectedReview[key] = value;
          this.setState({ selectedReview });
        })
        .catch((error) => {
          selectedReview[key] = "";
          this.setState({ selectedReview });
          this.props.enqueueSnackbar(
            error.response ? error.response.data.error.message : error.message,
            { variant: "error" },
          );
        });
    }
  }

  render() {
    const { postData, hiringPlans } = this.state;
    return (
      <div>
        <Grid container>
          <Grid item xs={12} md={12} sm={12}>
            <div style={{ width: 350 }}>
              <DynamicForm
                fields={textinputconverter({
                  value: postData.name,
                  label: "Title of requisition",
                  placeholder: "Enter title",
                })}
                onChange={(e) => this.handleChange("name", e)}
              />

              <DynamicForm
                fields={textareainputconverter({
                  value: postData.description,
                  label: "Requisition description",
                  placeholder: "Description",
                })}
                onChange={(e) => this.handleChange("description", e)}
              />
              <DynamicForm
                fields={selectinputconverter({
                  value: postData.hiringplanid,
                  placeholder: "Select plan",
                  label: "Which hiring plan should this be added to?",
                  options: hiringPlans,
                })}
                onChange={(selectedid) => {
                  this.handleChange("hiringplanid", selectedid);
                }}
              />
            </div>
          </Grid>
        </Grid>
      </div>
    );
  }
}
export default withSnackbar(define);
